import { onBeforeUnmount, onMounted, provide } from 'vue'
import type { InjectionKey, Ref } from 'vue'
import { registerContext, unregisterContext } from '../utils/contextRegistry'
import type { IOnboardingContext } from '../types/IOnboardingContext'

/** Сценарий ближайшего экрана или формы — по нему кнопка запуска внутри формы знает, что запускать */
export const ONBOARDING_SCENARIO_KEY: InjectionKey<string> = Symbol('onboardingScenario')

interface IUseOnboardingContextOptions {
  /** Имена контекстов, которые обслуживает компонент (например, форма и её панель задачи) */
  names: string[]

  /** Сценарий, который запускает кнопка «Обучение» внутри компонента */
  scenarioId?: string
  root: Ref<HTMLElement | null | undefined> | (() => HTMLElement | null)
  actions?: IOnboardingContext['actions']
}

/**
 * Регистрирует экран или форму в онбординге на время жизни компонента.
 * Работает одинаково при любом способе открытия формы: из таблицы, по маршруту,
 * глобально из уведомления или локальной модалкой.
 */
export function useOnboardingContext(options: IUseOnboardingContextOptions) {
  const getRoot = () => {
    const root = typeof options.root === 'function' ? options.root() : options.root.value

    return root ?? null
  }

  const contexts: IOnboardingContext[] = options.names.map(name => ({
    name,
    root: getRoot,
    actions: options.actions ?? {},
  }))

  if (options.scenarioId)
    provide(ONBOARDING_SCENARIO_KEY, options.scenarioId)

  onMounted(() => contexts.forEach(registerContext))
  onBeforeUnmount(() => contexts.forEach(unregisterContext))
}
